import { createContext } from 'react';

export const PageDataContext = createContext([{}, () => {}]);

export const TabContext = createContext(['', () => {}])


